// extracted by mini-css-extract-plugin
export default {"container":"R9UFnY","title":"gUKJE0","description":"RpSBjv","descriptionText":"KtXVa9"};